export default __webpack_public_path__ + "media/zurb/img/work/paysa-thumb2-2b3a9252baae984f3c191c41e0235ef4.png";